import React from 'react';

import Loader from 'components/Loader';
import ItemPost from 'templates/pages/WebinarOnDemandPost';

import withPreview from '@/hoc/withPreview';
import { webinarOnDemandPost } from 'constants/graphql/webinarOnDemandPost';

const WebinarOnDemandPost = ({ pageContext, loaded, ...props }) => {
  if (!loaded) return <Loader />;

  return <ItemPost {...pageContext} {...props} />;
};

const queryPreview = `
query WebinarOnDemandPostQuery($id: ID = "") {
  webinarOnDemand(id: $id, idType: DATABASE_ID, asPreview: true) {
    ${webinarOnDemandPost()}
    revisions(first:1) {
      nodes {
        ${webinarOnDemandPost()}
      }
    }
  }
}
`;

export default withPreview(WebinarOnDemandPost, {
  queryPreview,
});
